import React from 'react'

function InsuranceDisclaimer() {
  return (
    <div className="text-smaller">   
      <strong>
        <span className="text-dark">Insurance</span>
      </strong>
      <p>If you chose any of the add-on novated lease insurance products, it is included in the cost of your lease. You will receive your policy document when you enter into your lease. Oly Pty Ltd (ABN 69 674 252 629, authorised representative number 1308384) (Oly) is authorised by:<br />
        <ul>
          <li>Allianz Australia Insurance Limited (ABN 15 000 122 850, AFSL 234708) (Allianz) to provide general advice on and arrange Motor Vehicle Lease Insurance issued by Allianz.</li>
          <li>Pacific International Insurance Pty Ltd (ABN 83 169 311 193, AFSL 523921) (Pacific International Insurance) to provide general advice on and arrange Motor Vehicle Lease Insurance Options Policy issued by Pacific International Insurance.</li>
        </ul>
      </p>
      <strong>Insurance disclosures</strong>
      <p>The product disclosure statement (PDS) for each insurance product includes the full terms and conditions and 
        the financial services guide (FSG) includes information about the financial services Oly provides. The 
        target market determination (TMD) describes the target market for each insurance product, the distribution 
        conditions and other information about these insurances. You can obtain these documents by visiting the {' '}
        <a
          href="https://www.oly.com.au/novated-lease/insurance#pds"
          className="text-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Oly website
        </a>{' '} or contacting Oly at 1300 328 186 or <a
          href="mailto:hello@oly.com.au"
          className="text-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          hello@oly.com.au
        </a>.
      </p>
    </div>
  )
}

export default InsuranceDisclaimer
